import type {ILoyaltyProgram, ILoyaltyProgramMember} from "@torim-app/types";

import {adminUrlBuilder} from "@app/api/utils";

export class LoyaltyProgramApi {
  static readonly path = 'loyalty-program';

  static async getStats() {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/stats`);
    const response = await fetch(url, {
      method: 'get',
    });

    if (!response.ok)
      throw `Failed to get loyalty program statistics`;

    return await response.json() as {numberOfMembers: number};

  }

  static async getMembers(): Promise<ILoyaltyProgramMember[]> {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/members`);
    const response = await fetch(url, {
      method: 'get',
    });

    if (!response.ok)
      throw `Failed to get loyalty program members`;

    return await response.json() as ILoyaltyProgramMember[];
  }

  /**
   * SMS an existing customer a link to the public join page. `alreadyMember` comes back
   * true (and nothing is sent) when the customer is already in the club.
   */
  static async sendJoinInvite(customerId: string) {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/invite`);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({ customerId })
    });

    if (!response.ok)
      throw `Failed to send loyalty program invite`;

    return await response.json() as {
      message: string;
      phoneNumber: string;
      alreadyMember: boolean;
      smsOptedOut: boolean;
    };
  }

  static async createProgram() {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/settings`);
    const response = await fetch(url, {
      method: 'post',
      headers: {
        'content-type': 'application/json'
      },
      // body: JSON.stringify({})
    });
    if (!response.ok)
      throw `Failed to create loyalty program`;
  }

  static async updateProgram(
    body: Partial<ILoyaltyProgram>
  ) {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/settings`);
    const response = await fetch(url, {
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok)
      throw `Failed to update loyalty program`;
  }

  static async deactivateProgram() {
    const url = adminUrlBuilder({}, `${LoyaltyProgramApi.path}/settings`);
    const response = await fetch(url, {
      method: 'delete',
    });
    if (!response.ok)
      throw `Failed to deactivate loyalty program`;
  }
}
